<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre1" id="pgepubid00000"><span class="small"><span class="small">THE</span></span><br class="calibre3"/>
<br class="calibre3"/>
<big class="calibre4">BIGLOW PAPERS.</big></h1>
<p class="head"><span class="small">BY</span></p>
<h2 class="calibre6" id="pgepubid00001">JAMES RUSSELL LOWELL.</h2>
<p class="head"><big class="calibre4">Newly Edited,</big><br class="calibre7"/>
<br class="calibre7"/>
  WITH A PREFACE<br class="calibre7"/>
<br class="calibre7"/>
<span class="small">BY THE</span><br class="calibre7"/>
<br class="calibre7"/>
<big class="calibre4">AUTHOR OF "<i class="calibre8">TOM BROWN'S SCHOOL-DAYS</i>."</big></p>
<p class="calibre9"><a class="pcalibre pcalibre1" id="Page_v" title="[Pg v]"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?421375fc